import React from 'react';
import './Mapa.css';

const Mapa = () => (
  <section id="mapa" className="mapa">
    <div className="mapa__inner">
      <div className="mapa__info">
        <div className="eyebrow-cont">ENCUÉNTRANOS</div>
        <h2 className="section-title mapa__heading">Contáctanos</h2>
        <div className="mapa__divider"></div>

        <div className="mapa__details">
          <div className="mapa__item">
            <i className="fa-solid fa-location-dot"></i>
            <span>Av. Carlos Izaguirre Mz. A Lt 18 Urb. La Florida - SMP</span>
          </div>
          <div className="mapa__item">
            <i className="fa-solid fa-clock"></i>
            <span>
              Lun - Vier: 9:00 am - 6:00 pm
              <br />
              Sáb: 9:00 am - 13:00 pm
            </span>
          </div>
          <div className="mapa__item">
            <i className="fa-solid fa-phone"></i>
            <span>913 554 143</span>
          </div>
          <div className="mapa__item">
            <i className="fa-solid fa-envelope"></i>
            <span>Cashsolperuclientes@gmail.com</span>
          </div>
          <a
            href="https://wa.me/51913554143"
            target="_blank"
            rel="noreferrer"
            className="mapa__whatsapp"
          >
            <i className="fa-brands fa-whatsapp"></i>
            Escríbenos por WhatsApp
          </a>
        </div>
      </div>

      <div className="mapa__map">
        <iframe
          title="Ubicación Cash Sol SAC"
          src="https://www.google.com/maps?q=Avenida+Carlos+Izaguirre,+San+Martin+de+Porres,+Peru&output=embed"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </section>
);

export default Mapa;
